// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app-sidebar.has-preview[data-v-29bb9112] .app-sidebar-header__figure{background-size:cover}#app-sidebar.has-preview[data-v-29bb9112][data-mimetype=\"text/plain\"] .app-sidebar-header__figure,#app-sidebar.has-preview[data-v-29bb9112][data-mimetype=\"text/markdown\"] .app-sidebar-header__figure{background-size:contain}\n", ""]);
// Exports
module.exports = exports;
